class GiftListLinkUpdater {
  constructor() {
    this.code = localStorage.getItem('_dreambaby_giftlist_code');
    if (!this.code) {
      return;
    }

    this.updateLinks();
  }

  updateLinks() {
    const base = window.location.pathname.startsWith('/fr') ? '/fr/tools/liste-de-naissance' : '/tools/geboortelijst';

    document.querySelectorAll(`a[href="${base}"]`).forEach(link => {
     const prefix = window.location.pathname.startsWith('/fr') ? '/offrir/' : '/schenken/';
     
      link.href = `${base}${prefix}${this.code}`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new GiftListLinkUpdater());
